//import ismagReducer from "../../modules/ismagquery/store/reducer"
//import { disclaimerReducer } from "../disclaimer/reducer"
// import filestoreListReducer from "../../modules/filestores/store/reducer"
// import profileReducer from "../../modules/profile/reducer"
// import settingReducer from "../../modules/settings/reducer"



export type ResultTableState = {
    currentPage: number
}


export  type ResultTableAction =
    | {
        type: "ResultTable/INCREMENTPAGE"
    }
    | {
        type: "ResultTable/DECREMENTPAGE"
    }
    | {
        type: "ResultTable/RESETPAGING"
    }
  
    const initialState: ResultTableState = { currentPage : 1 }

 


export const resultTableReducer = (
        state: ResultTableState = initialState,
        action: ResultTableAction 
    ) => {
        // console.log("in ResulttableReducer state" + JSON.stringify(state) + " tms:" + Date.now())
        switch (action.type) {
            case "ResultTable/RESETPAGING":
                return { ...state, currentPage : 1} 
            case "ResultTable/DECREMENTPAGE":
                return { ...state, currentPage : Math.max(state.currentPage-1, 1)} // never decrement below 1
            case "ResultTable/INCREMENTPAGE":
                const newstate = { ...state, currentPage : state.currentPage+1 } 
                console.log("Received Increment message " + JSON.stringify(newstate))
                return newstate;
            default: return state
        }
    }
    